import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import {
  RENTAL_PORTAL_APPLICANT_APPROVAL_STATUSES,
  RENTAL_PORTAL_APPLICANT_CREDIT_CHECK_STATUSES,
  RENTAL_PORTAL_APPLICANT_INCOME_PROOF_STATUSES,
  RENTAL_PORTAL_APPLICANT_SCREENING_STATES,
} from '../../../../constants/rentalPortal'
import {
  APPLICANT_STAGES,
  RentalPortalApplicantIdentityCell,
} from '../../../RentalPortalApplicant'
import {
  getListingBuildingShortAddress,
  getListingUnitLabel,
} from '../../../RentalPortalListing'
import { TableDateCell, TableStatusCell, TableTextCell } from '../../../Table'
import { RentalPortalApplicantPortalCell } from '../../RentalPortalApplicantPortalCell'
import { APPLICANT_COLUMN_NAME } from '../RentalPortalApplicants.constants'

export function getIsApplicantRowActive({ focusedRow, id }) {
  return focusedRow === id
}

export function getApplicantCountDisplayValue(value) {
  return value == null ? null : String(value)
}

export function renderCell({ item, name, t, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case APPLICANT_COLUMN_NAME.Reference:
      return (
        <RentalPortalApplicantIdentityCell {...restProps} applicant={item} />
      )
    case APPLICANT_COLUMN_NAME.Stage:
      return (
        <TableStatusCell
          {...restProps}
          statuses={APPLICANT_STAGES}
          value={value}
        />
      )
    case APPLICANT_COLUMN_NAME.Listing:
      return (
        <TableTextCell {...restProps} value={item.listing?.listing_title} />
      )
    case APPLICANT_COLUMN_NAME.Building:
      return (
        <TableTextCell
          {...restProps}
          value={getListingBuildingShortAddress(item.listing?.flat?.building)}
        />
      )
    case APPLICANT_COLUMN_NAME.Flat:
      return (
        <TableTextCell
          {...restProps}
          value={getListingUnitLabel({ listing: item.listing, t })}
        />
      )
    case APPLICANT_COLUMN_NAME.Source:
      return <RentalPortalApplicantPortalCell {...restProps} applicant={item} />
    case APPLICANT_COLUMN_NAME.IncomeProofStatus:
      return (
        <TableStatusCell
          {...restProps}
          statuses={RENTAL_PORTAL_APPLICANT_INCOME_PROOF_STATUSES}
          value={value}
        />
      )
    case APPLICANT_COLUMN_NAME.CreditCheckStatus:
      return (
        <TableStatusCell
          {...restProps}
          statuses={RENTAL_PORTAL_APPLICANT_CREDIT_CHECK_STATUSES}
          value={value}
        />
      )
    case APPLICANT_COLUMN_NAME.ApprovalStatus:
      return (
        <TableStatusCell
          {...restProps}
          statuses={RENTAL_PORTAL_APPLICANT_APPROVAL_STATUSES}
          value={value}
        />
      )
    case APPLICANT_COLUMN_NAME.ScreeningState:
      return (
        <TableStatusCell
          {...restProps}
          statuses={RENTAL_PORTAL_APPLICANT_SCREENING_STATES}
          value={value}
        />
      )
    case APPLICANT_COLUMN_NAME.MoveInDate:
    case APPLICANT_COLUMN_NAME.ReceivedAt:
    case APPLICANT_COLUMN_NAME.SelectedAt:
    case APPLICANT_COLUMN_NAME.ApprovedAt:
    case APPLICANT_COLUMN_NAME.Created:
    case APPLICANT_COLUMN_NAME.Updated:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_SHORT_FORMAT}
          useTodayFormat={false}
          value={value}
        />
      )
    case APPLICANT_COLUMN_NAME.DocumentCount:
      return (
        <TableTextCell
          {...restProps}
          value={getApplicantCountDisplayValue(value)}
        />
      )
    default:
      return <TableTextCell {...restProps} value={value} />
  }
}
